import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54256ee2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "message ion-margin" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "buttons ion-margin-vertical ion-justify-content-between" }
const _hoisted_7 = { class: "ion-justify-content-center" }
const _hoisted_8 = {
  key: 0,
  class: "new-row"
}
const _hoisted_9 = { class: "ion-justify-content-center" }
const _hoisted_10 = { class: "ion-margin" }
const _hoisted_11 = {
  key: 0,
  class: "ion-margin"
}
const _hoisted_12 = { class: "ion-text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_import_data_modal = _resolveComponent("import-data-modal")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_auto_fill_select = _resolveComponent("auto-fill-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.dataLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ion_spinner),
          _createVNode(_component_ion_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('LoadingData')), 1)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_import_data_modal, {
            crop: _ctx.cropId,
            step: "seed",
            onImportData: _ctx.handleImportData
          }, null, 8, ["crop", "onImportData"]),
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-md": "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                fill: "solid",
                                "label-placement": "floating",
                                label: _ctx.translations[_ctx.currentLanguage].SewingDensity,
                                modelValue: _ctx.cropSeed.sewing_density_meters,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cropSeed.sewing_density_meters) = $event)),
                                onIonBlur: _ctx.updateCropSeedData
                              }, null, 8, ["label", "modelValue", "onIonBlur"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_text, { class: "unit" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitGrainProQuadratMeter')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-md": "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select, {
                                fill: "solid",
                                "label-placement": "floating",
                                label: _ctx.translations[_ctx.currentLanguage].SewingType,
                                placeholder: _ctx.translations[_ctx.currentLanguage].SelectSewingType,
                                modelValue: _ctx.cropSeed.sewing_type,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cropSeed.sewing_type) = $event)),
                                "cancel-text": _ctx.translations[_ctx.currentLanguage].Cancel,
                                "ok-text": _ctx.translations[_ctx.currentLanguage].Choose,
                                onIonChange: _ctx.updateCropSeedData
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sewingTypes, (sewing_type, index) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      key: index,
                                      value: sewing_type.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(sewing_type.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["label", "placeholder", "modelValue", "cancel-text", "ok-text", "onIonChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-md": "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                fill: "solid",
                                "label-placement": "floating",
                                label: _ctx.translations[_ctx.currentLanguage].SewingDensity,
                                modelValue: _ctx.cropSeed.sewing_density_kg,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cropSeed.sewing_density_kg) = $event)),
                                onIonBlur: _ctx.updateCropSeedData
                              }, null, 8, ["label", "modelValue", "onIonBlur"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_text, { class: "unit" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitKgProHa')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("i", null, _toDisplayString(_ctx.$t('RequiredForFarmSeedCostCalculation')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-md": "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select, {
                                fill: "solid",
                                "label-placement": "floating",
                                label: _ctx.translations[_ctx.currentLanguage].SewingDate,
                                placeholder: _ctx.translations[_ctx.currentLanguage].SelectSewingDate,
                                modelValue: _ctx.cropSeed.sewing_date,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cropSeed.sewing_date) = $event)),
                                "cancel-text": _ctx.translations[_ctx.currentLanguage].Cancel,
                                "ok-text": _ctx.translations[_ctx.currentLanguage].Choose,
                                onIonChange: _ctx.updateCropSeedData
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sewingDates, (sewing_date, index) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      key: index,
                                      value: sewing_date.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(sewing_date.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["label", "placeholder", "modelValue", "cancel-text", "ok-text", "onIonChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-margin-vertical ion-justify-content-left ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_checkbox, {
                        modelValue: _ctx.cropSeed.treatment_seed,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cropSeed.treatment_seed) = $event)),
                        onIonChange: _ctx.updateTreatmentSeed,
                        labelPlacement: "end"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('SeedTreatment')), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onIonChange"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-justify-content-left" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-md": "6"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('FarmSeeds')), 1),
                      _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                fill: "solid",
                                "label-placement": "floating",
                                label: _ctx.translations[_ctx.currentLanguage].Area,
                                modelValue: _ctx.cropSeed.area_farm_seed,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cropSeed.area_farm_seed) = $event)),
                                modelModifiers: { number: true },
                                onIonBlur: _ctx.updateCropSeedData
                              }, null, 8, ["label", "modelValue", "onIonBlur"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_text, { class: "unit" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitHa')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                fill: "solid",
                                "label-placement": "floating",
                                label: _ctx.translations[_ctx.currentLanguage].Cost,
                                modelValue: _ctx.cropSeed.total_cost_farm_seed,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cropSeed.total_cost_farm_seed) = $event)),
                                modelModifiers: { number: true },
                                onIonBlur: _ctx.updateCropSeedData
                              }, null, 8, ["label", "modelValue", "onIonBlur"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_text, { class: "unit" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        class: "ion-md-float-left",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showModalFarmSeedTotalCost = true))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.calculatorOutline
                          }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('SeedCostCalculator')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_modal, {
                        id: "farm_seed_total_cost",
                        "is-open": _ctx.showModalFarmSeedTotalCost,
                        onIonModalWillDismiss: _ctx.closeModal
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_content, { class: "ion-padding" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_title, { class: "ion-padding" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('FarmSeedTotalCostModalTitle')), 1)
                                ]),
                                _: 1
                              }),
                              (_ctx.showMessageFarmSeedTotalCostModal)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('WrongDataSubmitted')), 1),
                                    _createVNode(_component_ion_button, {
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showModalFarmSeedTotalCost = false)),
                                      color: "light"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('Close')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_openBlock(), _createBlock(_component_ion_grid, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, { size: "auto" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_input, {
                                                type: "number",
                                                fill: "solid",
                                                "label-placement": "floating",
                                                label: _ctx.translations[_ctx.currentLanguage].FarmSeedCost,
                                                modelValue: _ctx.cropSeed.price_farm_seed,
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.cropSeed.price_farm_seed) = $event)),
                                                modelModifiers: { number: true },
                                                onIonBlur: _ctx.updateFarmSeedCost
                                              }, null, 8, ["label", "modelValue", "onIonBlur"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_col, { size: "auto" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_text, { class: "unit" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProT')), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, { size: "auto" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_input, {
                                                type: "number",
                                                fill: "solid",
                                                "label-placement": "floating",
                                                label: _ctx.translations[_ctx.currentLanguage].Sorting,
                                                modelValue: _ctx.cropSeed.sorting_cost_farm_seed,
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cropSeed.sorting_cost_farm_seed) = $event)),
                                                modelModifiers: { number: true },
                                                onIonBlur: _ctx.updateFarmSeedCost
                                              }, null, 8, ["label", "modelValue", "onIonBlur"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_col, { size: "auto" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_text, { class: "unit" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProT')), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      (_ctx.cropSeed.treatment_seed)
                                        ? (_openBlock(), _createBlock(_component_ion_row, {
                                            key: 0,
                                            class: "ion-justify-content-left ion-align-items-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_col, { size: "auto" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_input, {
                                                    type: "number",
                                                    fill: "solid",
                                                    "label-placement": "floating",
                                                    label: _ctx.translations[_ctx.currentLanguage].Treatment,
                                                    modelValue: _ctx.cropSeed.treatment_cost_farm_seed,
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.cropSeed.treatment_cost_farm_seed) = $event)),
                                                    modelModifiers: { number: true },
                                                    onIonBlur: _ctx.updateFarmSeedCost
                                                  }, null, 8, ["label", "modelValue", "onIonBlur"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_ion_col, { size: "auto" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_text, { class: "unit" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProT')), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _hoisted_5
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, { size: "auto" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_input, {
                                                type: "number",
                                                "label-placement": "floating",
                                                class: "readonly",
                                                label: _ctx.translations[_ctx.currentLanguage].TotalCost,
                                                modelValue: _ctx.cropSeed.cost_farm_seed,
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.cropSeed.cost_farm_seed) = $event)),
                                                modelModifiers: { number: true },
                                                readonly: "true"
                                              }, null, 8, ["label", "modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_col, { size: "auto" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_text, { class: "unit" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProT')), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })),
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_ion_button, {
                                  onClick: _ctx.applyFarmSeedCost,
                                  type: "submit"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('Confirm')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_ion_button, {
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showModalFarmSeedTotalCost = false)),
                                  color: "light"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('Cancel')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["is-open", "onIonModalWillDismiss"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-md": "6"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('CertifiedSeeds')), 1),
                      _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                fill: "solid",
                                "label-placement": "floating",
                                label: _ctx.translations[_ctx.currentLanguage].Area,
                                modelValue: _ctx.cropSeed.area_certified_seed,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.cropSeed.area_certified_seed) = $event)),
                                modelModifiers: { number: true },
                                onIonBlur: _ctx.updateCropSeedData
                              }, null, 8, ["label", "modelValue", "onIonBlur"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_text, { class: "unit" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitHa')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { class: "ion-justify-content-left ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                fill: "solid",
                                "label-placement": "floating",
                                label: _ctx.translations[_ctx.currentLanguage].Cost,
                                modelValue: _ctx.cropSeed.cost_certified_seed,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.cropSeed.cost_certified_seed) = $event)),
                                modelModifiers: { number: true },
                                onIonBlur: _ctx.updateCropSeedData
                              }, null, 8, ["label", "modelValue", "onIonBlur"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_text, { class: "unit" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-margin-vertical ion-justify-content-center ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        type: "number",
                        "label-placement": "floating",
                        label: _ctx.translations[_ctx.currentLanguage].TotalCost,
                        modelValue: _ctx.cropSeed.seed_total_cost,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.cropSeed.seed_total_cost) = $event)),
                        modelModifiers: { number: true },
                        readonly: "true",
                        class: "readonly"
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_text, { class: "unit" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.mixedCrop)
                ? (_openBlock(), _createBlock(_component_ion_row, {
                    key: 0,
                    class: "ion-margin-vertical ion-justify-content-left ion-align-items-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { size: "auto" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('MixedCrop')), 1),
                          _createElementVNode("table", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cropSeed.mixed_crops, (mixed_crop, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, [
                                  _createVNode(_component_auto_fill_select, {
                                    options: _ctx.harvests,
                                    searchField: "crop_name",
                                    label: _ctx.translations[_ctx.currentLanguage].Crop,
                                    placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                                    selected: mixed_crop.name,
                                    clear: false,
                                    "onUpdate:modelValue": option => _ctx.handleSelected(option, mixed_crop, 'harvest', true)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" >")
                                    ]),
                                    _: 2
                                  }, 1032, ["options", "label", "placeholder", "selected", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_ion_input, {
                                    fill: "solid",
                                    "label-placement": "floating",
                                    "aria-label": _ctx.translations[_ctx.currentLanguage].Percent,
                                    type: "number",
                                    min: "0",
                                    max: "100",
                                    modelValue: mixed_crop.ratio,
                                    "onUpdate:modelValue": ($event: any) => ((mixed_crop.ratio) = $event),
                                    modelModifiers: { number: true },
                                    onIonBlur: ($event: any) => (_ctx.updateMixedCropData($event, mixed_crop))
                                  }, null, 8, ["aria-label", "modelValue", "onUpdate:modelValue", "onIonBlur"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_ion_text, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('PercentSewed')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("td", _hoisted_7, [
                                  _createVNode(_component_ion_button, {
                                    color: "danger",
                                    onClick: ($event: any) => (_ctx.deleteMixedCrop(mixed_crop.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ]))
                            }), 128)),
                            (_ctx.newMixedCrop)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_auto_fill_select, {
                                      options: _ctx.harvests,
                                      searchField: "crop_name",
                                      ref: "selectMixedCrop",
                                      label: _ctx.translations[_ctx.currentLanguage].Crop,
                                      placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = option => _ctx.handleSelected(option, _ctx.newMixedCrop, 'harvest', false))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" >")
                                      ]),
                                      _: 1
                                    }, 8, ["options", "label", "placeholder"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_ion_input, {
                                      fill: "solid",
                                      "label-placement": "floating",
                                      type: "number",
                                      min: "0",
                                      max: "100",
                                      "aria-label": _ctx.translations[_ctx.currentLanguage].Percent,
                                      value: _ctx.newMixedCrop.ratio,
                                      modelValue: _ctx.newMixedCrop.ratio,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newMixedCrop.ratio) = $event)),
                                      modelModifiers: { number: true }
                                    }, null, 8, ["aria-label", "value", "modelValue"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_ion_text, { class: "ion-text-no-wrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('PercentSewed')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("td", _hoisted_9, [
                                    _createVNode(_component_ion_button, { onClick: _ctx.addMixedCrop }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.addCircleOutline }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            (_ctx.errorMessageMixedCrop)
                              ? (_openBlock(), _createBlock(_component_ion_text, {
                                  key: 0,
                                  color: "danger"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.errorMessageMixedCrop), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_ion_text, { color: "danger" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_ion_button, {
              color: "secondary",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.previousStep($event, _ctx.cropSeed)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Previous')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              color: "primary",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.nextStep($event, _ctx.cropSeed)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Next')), 1)
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}